/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  DateOnlyCalendarAppointmentListTuple,
  GetMyActivitiesForDateRangeParams,
  GetMyActivitiesRequest,
  GetMyEventsForDateRangeParams,
  GetMyStatusForDateRangeParams
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetMyStatusUrl = () => {




  return `/api/Calendar/GetMyStatus`
}

export const getMyStatus = async (getMyStatusBody?: string[], options?: Parameters<typeof customInstance>[1]): Promise<DateOnlyCalendarAppointmentListTuple[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<DateOnlyCalendarAppointmentListTuple[]>(getGetMyStatusUrl(),
  {
    ...options,
    method: 'GET',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getMyStatusBody)
  }
);}





export const getGetMyStatusQueryKey = (getMyStatusBody?: BodyType<string[]>,) => {
    return [
    `/api/Calendar/GetMyStatus`, getMyStatusBody
    ] as const;
    }


export const getGetMyStatusQueryOptions = <TData = Awaited<ReturnType<typeof getMyStatus>>, TError = ErrorType<unknown>>(getMyStatusBody?: BodyType<string[]>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyStatusQueryKey(getMyStatusBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyStatus>>> = ({ signal }) => getMyStatus(getMyStatusBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getMyStatus>>>
export type GetMyStatusQueryError = ErrorType<unknown>


export function useGetMyStatus<TData = Awaited<ReturnType<typeof getMyStatus>>, TError = ErrorType<unknown>>(
 getMyStatusBody: undefined |  BodyType<string[]>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyStatus>>,
          TError,
          Awaited<ReturnType<typeof getMyStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyStatus<TData = Awaited<ReturnType<typeof getMyStatus>>, TError = ErrorType<unknown>>(
 getMyStatusBody?: BodyType<string[]>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyStatus>>,
          TError,
          Awaited<ReturnType<typeof getMyStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyStatus<TData = Awaited<ReturnType<typeof getMyStatus>>, TError = ErrorType<unknown>>(
 getMyStatusBody?: BodyType<string[]>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyStatus<TData = Awaited<ReturnType<typeof getMyStatus>>, TError = ErrorType<unknown>>(
 getMyStatusBody?: BodyType<string[]>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyStatusQueryOptions(getMyStatusBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMyStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMyStatus>>, TError = ErrorType<unknown>>(getMyStatusBody?: BodyType<string[]>, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyStatusQueryKey(getMyStatusBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyStatus>>> = ({ signal }) => getMyStatus(getMyStatusBody, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetMyStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMyStatus>>>
export type GetMyStatusSuspenseQueryError = ErrorType<unknown>


export function useGetMyStatusSuspense<TData = Awaited<ReturnType<typeof getMyStatus>>, TError = ErrorType<unknown>>(
 getMyStatusBody: undefined |  BodyType<string[]>, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyStatusSuspense<TData = Awaited<ReturnType<typeof getMyStatus>>, TError = ErrorType<unknown>>(
 getMyStatusBody?: BodyType<string[]>, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyStatusSuspense<TData = Awaited<ReturnType<typeof getMyStatus>>, TError = ErrorType<unknown>>(
 getMyStatusBody?: BodyType<string[]>, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyStatusSuspense<TData = Awaited<ReturnType<typeof getMyStatus>>, TError = ErrorType<unknown>>(
 getMyStatusBody?: BodyType<string[]>, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyStatusSuspenseQueryOptions(getMyStatusBody,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMyActivitiesUrl = () => {




  return `/api/Calendar/GetMyActivities`
}

export const getMyActivities = async (getMyActivitiesRequest?: GetMyActivitiesRequest[], options?: Parameters<typeof customInstance>[1]): Promise<DateOnlyCalendarAppointmentListTuple[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<DateOnlyCalendarAppointmentListTuple[]>(getGetMyActivitiesUrl(),
  {
    ...options,
    method: 'GET',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getMyActivitiesRequest)
  }
);}





export const getGetMyActivitiesQueryKey = (getMyActivitiesRequest?: BodyType<GetMyActivitiesRequest[]>,) => {
    return [
    `/api/Calendar/GetMyActivities`, getMyActivitiesRequest
    ] as const;
    }


export const getGetMyActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof getMyActivities>>, TError = ErrorType<unknown>>(getMyActivitiesRequest?: BodyType<GetMyActivitiesRequest[]>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyActivitiesQueryKey(getMyActivitiesRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyActivities>>> = ({ signal }) => getMyActivities(getMyActivitiesRequest, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyActivities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getMyActivities>>>
export type GetMyActivitiesQueryError = ErrorType<unknown>


export function useGetMyActivities<TData = Awaited<ReturnType<typeof getMyActivities>>, TError = ErrorType<unknown>>(
 getMyActivitiesRequest: undefined |  BodyType<GetMyActivitiesRequest[]>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyActivities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyActivities>>,
          TError,
          Awaited<ReturnType<typeof getMyActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyActivities<TData = Awaited<ReturnType<typeof getMyActivities>>, TError = ErrorType<unknown>>(
 getMyActivitiesRequest?: BodyType<GetMyActivitiesRequest[]>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyActivities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyActivities>>,
          TError,
          Awaited<ReturnType<typeof getMyActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyActivities<TData = Awaited<ReturnType<typeof getMyActivities>>, TError = ErrorType<unknown>>(
 getMyActivitiesRequest?: BodyType<GetMyActivitiesRequest[]>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyActivities<TData = Awaited<ReturnType<typeof getMyActivities>>, TError = ErrorType<unknown>>(
 getMyActivitiesRequest?: BodyType<GetMyActivitiesRequest[]>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyActivitiesQueryOptions(getMyActivitiesRequest,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMyActivitiesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMyActivities>>, TError = ErrorType<unknown>>(getMyActivitiesRequest?: BodyType<GetMyActivitiesRequest[]>, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyActivitiesQueryKey(getMyActivitiesRequest);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyActivities>>> = ({ signal }) => getMyActivities(getMyActivitiesRequest, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyActivities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetMyActivitiesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMyActivities>>>
export type GetMyActivitiesSuspenseQueryError = ErrorType<unknown>


export function useGetMyActivitiesSuspense<TData = Awaited<ReturnType<typeof getMyActivities>>, TError = ErrorType<unknown>>(
 getMyActivitiesRequest: undefined |  BodyType<GetMyActivitiesRequest[]>, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyActivitiesSuspense<TData = Awaited<ReturnType<typeof getMyActivities>>, TError = ErrorType<unknown>>(
 getMyActivitiesRequest?: BodyType<GetMyActivitiesRequest[]>, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyActivitiesSuspense<TData = Awaited<ReturnType<typeof getMyActivities>>, TError = ErrorType<unknown>>(
 getMyActivitiesRequest?: BodyType<GetMyActivitiesRequest[]>, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyActivitiesSuspense<TData = Awaited<ReturnType<typeof getMyActivities>>, TError = ErrorType<unknown>>(
 getMyActivitiesRequest?: BodyType<GetMyActivitiesRequest[]>, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyActivitiesSuspenseQueryOptions(getMyActivitiesRequest,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMyDutiesUrl = () => {




  return `/api/Calendar/GetMyDuties`
}

export const getMyDuties = async (getMyDutiesBody?: string[], options?: Parameters<typeof customInstance>[1]): Promise<DateOnlyCalendarAppointmentListTuple[]> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<DateOnlyCalendarAppointmentListTuple[]>(getGetMyDutiesUrl(),
  {
    ...options,
    method: 'GET',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getMyDutiesBody)
  }
);}





export const getGetMyDutiesQueryKey = (getMyDutiesBody?: BodyType<string[]>,) => {
    return [
    `/api/Calendar/GetMyDuties`, getMyDutiesBody
    ] as const;
    }


export const getGetMyDutiesQueryOptions = <TData = Awaited<ReturnType<typeof getMyDuties>>, TError = ErrorType<unknown>>(getMyDutiesBody?: BodyType<string[]>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyDuties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyDutiesQueryKey(getMyDutiesBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyDuties>>> = ({ signal }) => getMyDuties(getMyDutiesBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyDuties>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyDutiesQueryResult = NonNullable<Awaited<ReturnType<typeof getMyDuties>>>
export type GetMyDutiesQueryError = ErrorType<unknown>


export function useGetMyDuties<TData = Awaited<ReturnType<typeof getMyDuties>>, TError = ErrorType<unknown>>(
 getMyDutiesBody: undefined |  BodyType<string[]>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyDuties>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyDuties>>,
          TError,
          Awaited<ReturnType<typeof getMyDuties>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyDuties<TData = Awaited<ReturnType<typeof getMyDuties>>, TError = ErrorType<unknown>>(
 getMyDutiesBody?: BodyType<string[]>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyDuties>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyDuties>>,
          TError,
          Awaited<ReturnType<typeof getMyDuties>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyDuties<TData = Awaited<ReturnType<typeof getMyDuties>>, TError = ErrorType<unknown>>(
 getMyDutiesBody?: BodyType<string[]>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyDuties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyDuties<TData = Awaited<ReturnType<typeof getMyDuties>>, TError = ErrorType<unknown>>(
 getMyDutiesBody?: BodyType<string[]>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyDuties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyDutiesQueryOptions(getMyDutiesBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMyDutiesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMyDuties>>, TError = ErrorType<unknown>>(getMyDutiesBody?: BodyType<string[]>, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyDuties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyDutiesQueryKey(getMyDutiesBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyDuties>>> = ({ signal }) => getMyDuties(getMyDutiesBody, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyDuties>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetMyDutiesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMyDuties>>>
export type GetMyDutiesSuspenseQueryError = ErrorType<unknown>


export function useGetMyDutiesSuspense<TData = Awaited<ReturnType<typeof getMyDuties>>, TError = ErrorType<unknown>>(
 getMyDutiesBody: undefined |  BodyType<string[]>, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyDuties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyDutiesSuspense<TData = Awaited<ReturnType<typeof getMyDuties>>, TError = ErrorType<unknown>>(
 getMyDutiesBody?: BodyType<string[]>, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyDuties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyDutiesSuspense<TData = Awaited<ReturnType<typeof getMyDuties>>, TError = ErrorType<unknown>>(
 getMyDutiesBody?: BodyType<string[]>, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyDuties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyDutiesSuspense<TData = Awaited<ReturnType<typeof getMyDuties>>, TError = ErrorType<unknown>>(
 getMyDutiesBody?: BodyType<string[]>, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyDuties>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyDutiesSuspenseQueryOptions(getMyDutiesBody,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMyStatusForDateRangeUrl = (params?: GetMyStatusForDateRangeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Calendar/GetMyStatusForDateRange?${stringifiedParams}` : `/api/Calendar/GetMyStatusForDateRange`
}

export const getMyStatusForDateRange = async (params?: GetMyStatusForDateRangeParams, options?: Parameters<typeof customInstance>[1]): Promise<DateOnlyCalendarAppointmentListTuple[]> => {

  return customInstance<DateOnlyCalendarAppointmentListTuple[]>(getGetMyStatusForDateRangeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyStatusForDateRangeQueryKey = (params?: GetMyStatusForDateRangeParams,) => {
    return [
    `/api/Calendar/GetMyStatusForDateRange`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMyStatusForDateRangeQueryOptions = <TData = Awaited<ReturnType<typeof getMyStatusForDateRange>>, TError = ErrorType<unknown>>(params?: GetMyStatusForDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyStatusForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyStatusForDateRangeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyStatusForDateRange>>> = ({ signal }) => getMyStatusForDateRange(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyStatusForDateRange>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyStatusForDateRangeQueryResult = NonNullable<Awaited<ReturnType<typeof getMyStatusForDateRange>>>
export type GetMyStatusForDateRangeQueryError = ErrorType<unknown>


export function useGetMyStatusForDateRange<TData = Awaited<ReturnType<typeof getMyStatusForDateRange>>, TError = ErrorType<unknown>>(
 params: undefined |  GetMyStatusForDateRangeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyStatusForDateRange>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyStatusForDateRange>>,
          TError,
          Awaited<ReturnType<typeof getMyStatusForDateRange>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyStatusForDateRange<TData = Awaited<ReturnType<typeof getMyStatusForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetMyStatusForDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyStatusForDateRange>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyStatusForDateRange>>,
          TError,
          Awaited<ReturnType<typeof getMyStatusForDateRange>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyStatusForDateRange<TData = Awaited<ReturnType<typeof getMyStatusForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetMyStatusForDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyStatusForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyStatusForDateRange<TData = Awaited<ReturnType<typeof getMyStatusForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetMyStatusForDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyStatusForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyStatusForDateRangeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMyStatusForDateRangeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMyStatusForDateRange>>, TError = ErrorType<unknown>>(params?: GetMyStatusForDateRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyStatusForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyStatusForDateRangeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyStatusForDateRange>>> = ({ signal }) => getMyStatusForDateRange(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyStatusForDateRange>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetMyStatusForDateRangeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMyStatusForDateRange>>>
export type GetMyStatusForDateRangeSuspenseQueryError = ErrorType<unknown>


export function useGetMyStatusForDateRangeSuspense<TData = Awaited<ReturnType<typeof getMyStatusForDateRange>>, TError = ErrorType<unknown>>(
 params: undefined |  GetMyStatusForDateRangeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyStatusForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyStatusForDateRangeSuspense<TData = Awaited<ReturnType<typeof getMyStatusForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetMyStatusForDateRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyStatusForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyStatusForDateRangeSuspense<TData = Awaited<ReturnType<typeof getMyStatusForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetMyStatusForDateRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyStatusForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyStatusForDateRangeSuspense<TData = Awaited<ReturnType<typeof getMyStatusForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetMyStatusForDateRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyStatusForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyStatusForDateRangeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMyActivitiesForDateRangeUrl = (params?: GetMyActivitiesForDateRangeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Calendar/GetMyActivitiesForDateRange?${stringifiedParams}` : `/api/Calendar/GetMyActivitiesForDateRange`
}

export const getMyActivitiesForDateRange = async (params?: GetMyActivitiesForDateRangeParams, options?: Parameters<typeof customInstance>[1]): Promise<DateOnlyCalendarAppointmentListTuple[]> => {

  return customInstance<DateOnlyCalendarAppointmentListTuple[]>(getGetMyActivitiesForDateRangeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyActivitiesForDateRangeQueryKey = (params?: GetMyActivitiesForDateRangeParams,) => {
    return [
    `/api/Calendar/GetMyActivitiesForDateRange`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMyActivitiesForDateRangeQueryOptions = <TData = Awaited<ReturnType<typeof getMyActivitiesForDateRange>>, TError = ErrorType<unknown>>(params?: GetMyActivitiesForDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyActivitiesForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyActivitiesForDateRangeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyActivitiesForDateRange>>> = ({ signal }) => getMyActivitiesForDateRange(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyActivitiesForDateRange>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyActivitiesForDateRangeQueryResult = NonNullable<Awaited<ReturnType<typeof getMyActivitiesForDateRange>>>
export type GetMyActivitiesForDateRangeQueryError = ErrorType<unknown>


export function useGetMyActivitiesForDateRange<TData = Awaited<ReturnType<typeof getMyActivitiesForDateRange>>, TError = ErrorType<unknown>>(
 params: undefined |  GetMyActivitiesForDateRangeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyActivitiesForDateRange>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyActivitiesForDateRange>>,
          TError,
          Awaited<ReturnType<typeof getMyActivitiesForDateRange>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyActivitiesForDateRange<TData = Awaited<ReturnType<typeof getMyActivitiesForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetMyActivitiesForDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyActivitiesForDateRange>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyActivitiesForDateRange>>,
          TError,
          Awaited<ReturnType<typeof getMyActivitiesForDateRange>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyActivitiesForDateRange<TData = Awaited<ReturnType<typeof getMyActivitiesForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetMyActivitiesForDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyActivitiesForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyActivitiesForDateRange<TData = Awaited<ReturnType<typeof getMyActivitiesForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetMyActivitiesForDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyActivitiesForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyActivitiesForDateRangeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMyActivitiesForDateRangeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMyActivitiesForDateRange>>, TError = ErrorType<unknown>>(params?: GetMyActivitiesForDateRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyActivitiesForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyActivitiesForDateRangeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyActivitiesForDateRange>>> = ({ signal }) => getMyActivitiesForDateRange(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyActivitiesForDateRange>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetMyActivitiesForDateRangeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMyActivitiesForDateRange>>>
export type GetMyActivitiesForDateRangeSuspenseQueryError = ErrorType<unknown>


export function useGetMyActivitiesForDateRangeSuspense<TData = Awaited<ReturnType<typeof getMyActivitiesForDateRange>>, TError = ErrorType<unknown>>(
 params: undefined |  GetMyActivitiesForDateRangeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyActivitiesForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyActivitiesForDateRangeSuspense<TData = Awaited<ReturnType<typeof getMyActivitiesForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetMyActivitiesForDateRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyActivitiesForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyActivitiesForDateRangeSuspense<TData = Awaited<ReturnType<typeof getMyActivitiesForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetMyActivitiesForDateRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyActivitiesForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyActivitiesForDateRangeSuspense<TData = Awaited<ReturnType<typeof getMyActivitiesForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetMyActivitiesForDateRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyActivitiesForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyActivitiesForDateRangeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMyEventsForDateRangeUrl = (params?: GetMyEventsForDateRangeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Calendar/GetMyEventsForDateRange?${stringifiedParams}` : `/api/Calendar/GetMyEventsForDateRange`
}

export const getMyEventsForDateRange = async (params?: GetMyEventsForDateRangeParams, options?: Parameters<typeof customInstance>[1]): Promise<DateOnlyCalendarAppointmentListTuple[]> => {

  return customInstance<DateOnlyCalendarAppointmentListTuple[]>(getGetMyEventsForDateRangeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyEventsForDateRangeQueryKey = (params?: GetMyEventsForDateRangeParams,) => {
    return [
    `/api/Calendar/GetMyEventsForDateRange`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMyEventsForDateRangeQueryOptions = <TData = Awaited<ReturnType<typeof getMyEventsForDateRange>>, TError = ErrorType<unknown>>(params?: GetMyEventsForDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyEventsForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyEventsForDateRangeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyEventsForDateRange>>> = ({ signal }) => getMyEventsForDateRange(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyEventsForDateRange>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyEventsForDateRangeQueryResult = NonNullable<Awaited<ReturnType<typeof getMyEventsForDateRange>>>
export type GetMyEventsForDateRangeQueryError = ErrorType<unknown>


export function useGetMyEventsForDateRange<TData = Awaited<ReturnType<typeof getMyEventsForDateRange>>, TError = ErrorType<unknown>>(
 params: undefined |  GetMyEventsForDateRangeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyEventsForDateRange>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyEventsForDateRange>>,
          TError,
          Awaited<ReturnType<typeof getMyEventsForDateRange>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyEventsForDateRange<TData = Awaited<ReturnType<typeof getMyEventsForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetMyEventsForDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyEventsForDateRange>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyEventsForDateRange>>,
          TError,
          Awaited<ReturnType<typeof getMyEventsForDateRange>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyEventsForDateRange<TData = Awaited<ReturnType<typeof getMyEventsForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetMyEventsForDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyEventsForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyEventsForDateRange<TData = Awaited<ReturnType<typeof getMyEventsForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetMyEventsForDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyEventsForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyEventsForDateRangeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMyEventsForDateRangeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMyEventsForDateRange>>, TError = ErrorType<unknown>>(params?: GetMyEventsForDateRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyEventsForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyEventsForDateRangeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyEventsForDateRange>>> = ({ signal }) => getMyEventsForDateRange(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyEventsForDateRange>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetMyEventsForDateRangeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMyEventsForDateRange>>>
export type GetMyEventsForDateRangeSuspenseQueryError = ErrorType<unknown>


export function useGetMyEventsForDateRangeSuspense<TData = Awaited<ReturnType<typeof getMyEventsForDateRange>>, TError = ErrorType<unknown>>(
 params: undefined |  GetMyEventsForDateRangeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyEventsForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyEventsForDateRangeSuspense<TData = Awaited<ReturnType<typeof getMyEventsForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetMyEventsForDateRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyEventsForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyEventsForDateRangeSuspense<TData = Awaited<ReturnType<typeof getMyEventsForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetMyEventsForDateRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyEventsForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyEventsForDateRangeSuspense<TData = Awaited<ReturnType<typeof getMyEventsForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetMyEventsForDateRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyEventsForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyEventsForDateRangeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






